module.exports = __webpack_public_path__ + "static/media/fill.47be44f8.svg";